export const ACCESS_FORBIDDEN_MESSAGE_TEXT = '403: User has no access.';
export const NO_USER_PERMISSION_MESSAGE_TEXT =
  '403: User doesn’t have permissions.';
export const SESSION_EXPIRED_MESSAGE_TEXT =
  'Session Expired: For your security, please log in again.';
export const INVALID_TOKEN_MESSAGE_TEXT = 'Invalid token, please log in again.';
export const UNKNOWN_ERROR = 'Unknown error';
